
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.5 17c.428 0 .789.149 1.074.44.282.29.426.647.426 1.06 0 .413-.144.77-.426 1.06-.285.291-.646.44-1.074.44-.415 0-.772-.148-1.06-.44A1.444 1.444 0 0110 18.5c0-.414.148-.77.44-1.062.288-.29.645-.438 1.06-.438zm.584-13c1.331 0 2.492.366 3.449 1.089C16.507 5.825 17 6.858 17 8.16c0 .612-.15 1.2-.444 1.742-.287.528-.64.99-1.049 1.372l-1.16 1.084a5.49 5.49 0 00-.94 1.136 2.357 2.357 0 00-.366 1.247V15h-2.538v-.258c0-.645.148-1.254.437-1.808a5.102 5.102 0 011.054-1.398l1.158-1.065c.359-.328.675-.693.94-1.086.246-.359.37-.745.37-1.147 0-.606-.21-1.055-.638-1.37-.444-.327-1.037-.492-1.761-.492-1.46 0-2.368.596-2.777 1.82l-.1.3L7 7.33l.075-.206c.378-1.014 1.032-1.8 1.943-2.333C9.92 4.266 10.951 4 12.084 4z"}})])
          )
        }
      }
    